import React, { useState } from 'react';
import { GenericReportingDropdowns } from '../../containers/GenericReportingDropdowns';

const MarketingReportingPageDropdowns = () => {

    return (
      <div>
        <GenericReportingDropdowns
          includeDateRange={true}
          includeGranularity={true}
          includeTooltipsAndTitles={false}
          containerStyle="dropdown-container"
          renderAsButton={true}
          includeCompareDateRange={true}
          includeMarketingBreakdown={true}
        />
      </div>
    );
};

export default MarketingReportingPageDropdowns;